import moment from 'moment';

export const daysFromNow = (from: Date) => {
  return moment().diff(moment(from), 'days');
};
